<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
                     :hidden-default-button="!collectionData.length ? true : false"
                     @updateValues="setupUpdateValues">
      <button @click="$emit('updateValues', {'view': 'listar'});"
              class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
             stroke="currentColor" class="inline-block w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
        </svg>
        <span class="ml-3">Volver</span>
      </button>
    </HeaderComponent>
    <template v-if="!collectionData.length && !queries.search">
      <div class="grid grid-cols-6 gap-6 items-end">
        <div class="col-span-6 sm:col-span-2">
          <label for="saldo_inicial" class="block text-sm font-medium text-gray-700">Saldo inicial</label>
          <input type="text" id="saldo_inicial" v-model="saldoInicial.valor"
                 class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-2">
          <label for="tipo" class="block text-sm font-medium text-gray-700">Tipo</label>
          <select id="tipo" v-model="saldoInicial.tipo"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value="" selected>Seleccione un tipo de movimiento...</option>
            <option value="ingreso">Ingreso</option>
            <option value="egreso">Egreso</option>
          </select>
        </div>
        <button type="button"
                @click="crearMovimientosPorSaldoInicial()"
                v-text="'Guardar saldo inicial'"
                class="col-span-6 sm:col-span-2 sm:h-4/5 rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        </button>
      </div>
      <div class="my-3">
        <p class="text-left font-bold">Importante:</p>
        <p class="text-left"><b>-</b> Al crearse este movimiento inicial, se crearán todos los movimientos
          correspondientes a los días del mes del extracto, con los valores en 0.</p>
        <p class="text-left font-bold">Nota:</p>
        <p class="text-left"><b>-</b> Los números con decimales deben ir separados por un punto.</p>
      </div>
    </template>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedMovimientoBancario" :table-columns="tableColumns"
                    :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
                    :custom-update-selected-data="customUpdateSelectedData"
                    :custom-update-collection-data="customUpdateCollectionData"
                    :customStateHidden="(data) => data['dia'] !== 'Valor inicial'"
                    @updateValues="setupUpdateValues"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedMovimientoBancario"
                           :load-data="{...loadDataMovimientoBancario, extracto_bancario_id: selectedExtractoBancario.id, dia: loadDataMovimientoBancario.dia === 0 ? undefined : loadDataMovimientoBancario.dia}"
                           :options="{list: {queries: {where: 'extracto_bancario_id = ' + selectedExtractoBancario.id + ', table.estado = 1, NOT (dia = 0, valor = 0)'}}}"
                           :entity="entity" :auth-token="authToken"
                           :list-api="listApi" :queries="queries" :custom-update-load-data="customUpdateLoadData"
                           @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :load-data="loadDataMovimientoBancario"
                 :auth-token="authToken"
                 :selectedExtractoBancario="selectedExtractoBancario"
                 :max-days="getDaysInMonth(selectedExtractoBancario.mes, selectedExtractoBancario.year)"
                 :mes="selectedExtractoBancario.mes"
                 :year="selectedExtractoBancario.year"
                 :view="view"
                 :custom-update-value-data="customUpdateValueData" @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import {
  copiaProfunda, generateTextError,
  getCurrentMonth, getDaysInMonth,
  separateNumberByComma,
  swal, useAPIRest, verifyHttpCode,
} from "@/common/constants";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import {listCollectionData, useLayoutMain} from "@/layouts/main";
import MovimientosBancariosCrearActualizarComponent
  from "@/components/rendimientos/components/MovimientosBancariosCrearActualizarComponent.vue";

export default {
  name: 'MovimientosBancariosCRUD',
  props: ['selectedExtractoBancario'],
  emits: ['updateValues'],
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    MovimientosBancariosCrearActualizarComponent
  },
  data: function () {
    return {
      Object: Object,
      title: 'Movimientos bancarios del mes de ' + getCurrentMonth(this.selectedExtractoBancario.mes),
      entity: {gender: 'm', value: 'movimiento bancario'},
      childFormComponent: 'MovimientosBancariosCrearActualizarComponent',
      getDaysInMonth: getDaysInMonth,
      tableColumns: {
        'dia': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Día'
        },
        'valor': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Valor'
        },
        'tipo': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Tipo de movimiento'
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de creación'
        }
      }
    }
  },
  async setup(props) {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const authToken = ref(authStored.authToken);
    const saldoInicial = ref({
      valor: 0,
      tipo: ''
    });
    const selectedMovimientoBancario = ref({
      id: '',
      dia: '',
      valor: '',
      tipo: '',
      estado: ''
    });
    const loadDataMovimientoBancario = ref({
      dia: '',
      valor: '',
      tipo: '',
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_MOVIMIENTOBANCARIO_CREATE,
      list: process.env.VUE_APP_NEST_MOVIMIENTOBANCARIO_FINDALL,
      update: process.env.VUE_APP_NEST_MOVIMIENTOBANCARIO_UPDATE,
      updateState: process.env.VUE_APP_NEST_MOVIMIENTOBANCARIO_UPDATESTATE
    });
    const customUpdateValueData = (key, value) => {
      if (['extracto_bancario_id', 'dia'].includes(key)) return value !== '' ? Number(value) : value;
      return value;
    };
    const customUpdateSelectedData = (selectedCollectionData) => {
      const updatedSelectedData = {};
      for (const key of Object.keys(selectedMovimientoBancario.value)) {
        updatedSelectedData[key] = customUpdateValueData(key, selectedCollectionData[key]);
      }
      selectedMovimientoBancario.value = updatedSelectedData;
    }
    const customUpdateLoadData = () => {
      for (const key in loadDataMovimientoBancario.value) {
        let value = loadDataMovimientoBancario.value[key];
        value = customUpdateValueData(key, value);
      }
    };
    const customUpdateCollectionData = () => {
      const copyCollectionData = copiaProfunda(collectionData.value);
      for (const copyData of copyCollectionData) {
        copyData['dia'] = copyData['dia'] ? copyData['dia'] : 'Valor inicial';
        copyData['valor'] = separateNumberByComma(copyData['valor']);
        copyData['tipo'] = copyData['tipo'].toUpperCase();
      }
      return copyCollectionData;
    };

    const crearMovimientosPorSaldoInicial = async () => {
      if (Object.values(saldoInicial.value).filter(campo => campo === '').length) {
        await swal.fire('Por favor rellene todos los campos requeridos', '', 'error')
      } else {
        const days = Array.from(
            {length: getDaysInMonth(props.selectedExtractoBancario.mes, props.selectedExtractoBancario.year)},
            (_, i) => i + 1,
        );
        const movimientos = [];
        movimientos.push({
          extracto_bancario_id: props.selectedExtractoBancario.id,
          dia: 0,
          valor: saldoInicial.value.valor,
          tipo: saldoInicial.value.tipo
        })
        movimientos.push({
          extracto_bancario_id: props.selectedExtractoBancario.id,
          dia: 0,
          valor: 0,
          tipo: saldoInicial.value.tipo === "ingreso" ? "egreso" : "ingreso"
        })
        for (const day of days) {
          movimientos.push({
            extracto_bancario_id: props.selectedExtractoBancario.id,
            dia: day,
            valor: '0',
            tipo: 'ingreso'
          });
          movimientos.push({
            extracto_bancario_id: props.selectedExtractoBancario.id,
            dia: day,
            valor: '0',
            tipo: 'egreso'
          });
        }
        await useAPIRest(process.env.VUE_APP_NEST_MOVIMIENTOBANCARIO_CREATEMASS, 'POST', authToken.value, movimientos).then(resJSON => {
          const {statusCode} = resJSON;
          delete resJSON.statusCode;
          const textoError = generateTextError(resJSON);
          if (verifyHttpCode(statusCode, 'success')) swal.fire('¡Los movimientos fueron creados exitosamente!', '', 'success').then(async () => {
            await listCollectionData(listApi['list'], setupUpdateValues, authToken.value, undefined, undefined, undefined, undefined, undefined, 'extracto_bancario_id = ' + props.selectedExtractoBancario.id + ', table.estado = 1, NOT (dia = 0, valor = 0)', undefined, undefined)
          });
          else swal.fire(textoError, '', 'error');
        });
      }
    }

    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedMovimientoBancario, loadDataMovimientoBancario, listApi, {where: 'extracto_bancario_id = ' + props.selectedExtractoBancario.id + ', table.estado = 1, NOT (dia = 0, valor = 0)'});
    return {
      view,
      collectionData,
      authToken,
      selectedMovimientoBancario,
      loadDataMovimientoBancario,
      listApi,
      paginate,
      queries,
      saldoInicial,
      setupUpdateValues,
      cleanLoadSelectedData,
      customUpdateSelectedData,
      customUpdateCollectionData,
      customUpdateLoadData,
      customUpdateValueData,
      crearMovimientosPorSaldoInicial,
    };
  }
}
</script>
